export enum ApplicationStatus {
    Pending = 'pending',
    Submitted = 'submitted'
}